import React from "react";

import Icon from "platopulse/components/Icon.jsx";

const FullscreenIcon = ({ isFullscreen, ...props }) =>
    <Icon name={isFullscreen ? "contract" : "expand"} {...props} />

export default FullscreenIcon;



// WEBPACK FOOTER //
// ./components/icons/FullscreenIcon.jsx